export function formatDate(seconds) {
  const date = new Date(parseInt(seconds) * 1000);

  const formattedDate = date.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
}
